function parseKeyframeId(id) {
    const n = Number.parseInt(id, 10);
    return Number.isFinite(n) ? n : null;
}
/**
 * Düzenleme yapılırken state’in yazılacağı hedef: keyframe satırı veya default state (keyframe yok).
 *
 * Kural (eski `keyframesAtCursor` ile uyumlu):
 * 1. `selectedKeyframe` bu layer’a ait ve listede varsa → o keyframe.
 * 2. Cursor karesinde keyframe varsa → o keyframe.
 * 3. Cursor’dan küçük en büyük `frame` (hemen önceki keyframe) → o keyframe.
 * 4. Hiç keyframe yoksa → `default` (sunucuda `keyFrameId === 0`).
 */
export function resolveStateTarget({ layerId, currentFrame, layerKeyframes, selectedKeyframe, }) {
    const list = layerKeyframes ?? [];
    if (selectedKeyframe?.layerId === layerId) {
        const bySelection = list.find((k) => k.frame === selectedKeyframe.frame);
        if (bySelection) {
            return {
                kind: 'keyframe',
                keyframeId: parseKeyframeId(bySelection.id),
                frame: bySelection.frame,
                layerId,
                keyframe: bySelection,
            };
        }
    }
    const atCursor = list.find((k) => k.frame === currentFrame);
    if (atCursor) {
        return {
            kind: 'keyframe',
            keyframeId: parseKeyframeId(atCursor.id),
            frame: atCursor.frame,
            layerId,
            keyframe: atCursor,
        };
    }
    const before = list
        .filter((k) => k.frame < currentFrame)
        .sort((a, b) => b.frame - a.frame)[0];
    if (before) {
        return {
            kind: 'keyframe',
            keyframeId: parseKeyframeId(before.id),
            frame: before.frame,
            layerId,
            keyframe: before,
        };
    }
    return { kind: 'default', layerId };
}
